import React, { useState } from 'react';
import { Phone, Menu, X, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    name: 'About Us',
    href: '/about'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Employees',
    href: '/employees'
  }, {
    name: 'FAQ',
    href: '/faq'
  }];
  return <>
      <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm" data-id="element-87">
        <div className="container mx-auto px-4 md:px-6" data-id="element-88">
          <div className="flex items-center justify-between h-20 lg:h-24" data-id="element-89">
            {/* Logo Section */}
            <Link to="/" className="flex items-center gap-3 shrink-0 group" aria-label="CareBridge Home" data-id="element-90">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-brand-blue rounded-xl flex items-center justify-center shadow-lg shadow-blue-900/20 group-hover:scale-105 transition-transform" data-id="element-91">
                <span className="text-white font-bold text-xl md:text-2xl" data-id="element-92">
                  C
                </span>
              </div>
              <div className="flex flex-col" data-id="element-93">
                <span className="text-brand-blue font-black text-lg md:text-xl leading-none tracking-tighter" data-id="element-94">
                  CAREBRIDGE
                </span>
                <span className="text-gray-400 text-[9px] md:text-[10px] font-bold tracking-[0.2em] uppercase mt-0.5" data-id="element-95">
                  Transportation
                </span>
              </div>
            </Link>

            {/* Desktop Navigation - Centered */}
            <nav className="hidden xl:flex items-center bg-gray-50/50 px-2 py-1.5 rounded-full border border-gray-100" aria-label="Main Navigation" data-id="element-96">
              {navLinks.map(item => <Link key={item.name} to={item.href} className="px-5 py-2 text-brand-blue font-bold text-sm hover:text-blue-600 transition-colors focus-visible:ring-2 focus-visible:ring-blue-400 rounded-full outline-none whitespace-nowrap" data-id="element-97">
                  {item.name}
                </Link>)}
            </nav>

            {/* Actions Section */}
            <div className="flex items-center gap-3 md:gap-6" data-id="element-98">
              <a href="tel:5551234567" className="hidden md:flex items-center gap-2.5 text-brand-blue font-extrabold text-base lg:text-lg hover:text-blue-700 transition-colors" aria-label="Call us at (555) 123-4567" data-id="element-99">
                <div className="w-9 h-9 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-100">
                  <Phone size={18} className="fill-brand-blue" aria-hidden="true" data-id="element-101" />
                </div>
                <span className="hidden lg:inline" data-id="element-102">(555) 123-4567</span>
              </a>

              <div className="hidden sm:flex items-center gap-3" data-id="element-103">
                <button className="bg-brand-blue text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-blue-800 transition-all shadow-md shadow-blue-900/10 focus-visible:ring-4 focus-visible:ring-blue-400 outline-none" data-id="element-104">
                  Careers
                </button>
                <button className="bg-brand-blue text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-blue-800 transition-all shadow-md shadow-blue-900/10 focus-visible:ring-4 focus-visible:ring-blue-400 outline-none" data-id="element-105">
                  Pay Now
                </button>
              </div>

              <button className="xl:hidden w-11 h-11 flex items-center justify-center bg-gray-50 text-brand-blue rounded-full hover:bg-gray-100 transition-colors focus-visible:ring-4 focus-visible:ring-blue-400 outline-none" onClick={() => setIsMenuOpen(true)} aria-label="Open menu" aria-expanded={isMenuOpen} data-id="element-106">
                <Menu size={24} data-id="element-107" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay - Outside the header tag to avoid stacking context issues */}
      <AnimatePresence data-id="element-108">
        {isMenuOpen && <div className="fixed inset-0 z-[99999] xl:hidden" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }} data-id="element-109">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMenuOpen(false)} className="absolute inset-0 bg-black/60 backdrop-blur-md" data-id="element-110" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="absolute top-0 right-0 bottom-0 w-[85%] max-w-sm bg-white shadow-2xl flex flex-col" data-id="element-111">
              <div className="p-6 flex items-center justify-between border-b border-gray-100" data-id="element-112">
                <span className="font-black text-brand-blue tracking-tighter" data-id="element-113">
                  MENU
                </span>
                <button onClick={() => setIsMenuOpen(false)} className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-full text-gray-500" data-id="element-114">
                  <X size={20} data-id="element-115" />
                </button>
              </div>

              <div className="flex-grow overflow-y-auto p-6" data-id="element-116">
                <nav className="flex flex-col gap-2" data-id="element-117">
                  {navLinks.map(item => <Link key={item.name} to={item.href} onClick={() => setIsMenuOpen(false)} className="flex items-center justify-between p-4 rounded-2xl bg-gray-50 text-brand-blue font-bold text-lg hover:bg-brand-light transition-colors group" data-id="element-118">
                      {item.name}
                      <ChevronRight size={20} className="text-gray-300 group-hover:translate-x-1 transition-transform" data-id="element-119" />
                    </Link>)}
                </nav>

                <div className="mt-8 space-y-4" data-id="element-120">
                  <a href="tel:5551234567" className="flex items-center gap-4 p-4 rounded-2xl border-2 border-brand-blue text-brand-blue font-black text-xl justify-center" data-id="element-121">
                    <Phone size={24} className="fill-brand-blue" data-id="element-122" />
                    (555) 123-4567
                  </a>
                  <div className="grid grid-cols-2 gap-3" data-id="element-123">
                    <button className="bg-brand-blue text-white py-4 rounded-2xl font-bold" data-id="element-124">
                      Careers
                    </button>
                    <button className="bg-brand-blue text-white py-4 rounded-2xl font-bold" data-id="element-125">
                      Pay Now
                    </button>
                  </div>
                </div>
              </div>

              <div className="p-8 border-t border-gray-50 text-center" data-id="element-126">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-127">
                  CareBridge Transportation
                </p>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}